const ENDPOINT_BASE='/users/';

export const getSignupUrl = () => {
    return ENDPOINT_BASE;
}

export const getLoginUrl = () => {
    return ENDPOINT_BASE+'login';
}

export const getLogoutUrl = () => {
    return ENDPOINT_BASE+'logout';
}

export const getUserUrl = (username) => {
    return ENDPOINT_BASE+(username ? '/'+username : '');
}

export const getUsersUrl = () => {
    return ENDPOINT_BASE+'all';
}

export const getUpdateMailUrl = () => {
    return ENDPOINT_BASE+'email';
}

export const getVerificationUrl = () => {
    return ENDPOINT_BASE+'verification';
}

export const getResetUrl = () => {
    return ENDPOINT_BASE+'password/reset';
}

export const getUpdatePasswordUrl = () => {
    return ENDPOINT_BASE+'password/update';
}

export const getVerificationCodeUrl = () => {
    return '/code/verification';
}

export const getResetCodeUrl = () => {
    return '/code/reset';
}

export const getPropicUrl = (path) => {
    if(path) return process.env.REACT_APP_BASE_URL+path;
}

export const getUpdatePropicUrl = () => {
    return ENDPOINT_BASE+'propic';
}

export const getCheckTokenUrl = () => {
    return '/check-token';
}

export const getGoogleAuthUrl = () => {
    const rootUrl = process.env.REACT_APP_GOOGLE_ROOT_URL;
    const options = {
        redirect_uri: process.env.REACT_APP_GOOGLE_OAUTH_REDIRECT_URL,
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        access_type: 'offline',
        response_type: 'code',
        prompt: 'consent',
        scope: [
            'https://www.googleapis.com/auth/userinfo.profile',
            'https://www.googleapis.com/auth/userinfo.email'
        ].join(' ')
    };
    const query = new URLSearchParams(options);

    return rootUrl+'?'+query.toString();
}

export const getDiscordAuthUrl = () => {
    const rootUrl = process.env.REACT_APP_DISCORD_ROOT_URL;
    const options = {
        redirect_uri: process.env.REACT_APP_DISCORD_OAUTH_REDIRECT_URL,
        client_id: process.env.REACT_APP_DISCORD_CLIENT_ID,
        response_type: 'code',
        prompt: 'consent',
        scope:['identify', 'email'].join(' ')
    };
    const query = new URLSearchParams(options);

    return rootUrl+'?'+query.toString();
}